import styled from 'styled-components/macro';

import { background } from 'variables/colors';

export const PageTitle = styled.h1`
  margin-bottom: 2em;
`;

export const Layout = styled.div`
  display: flex;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${({ disablePadding }) => (disablePadding ? '0' : '3em 1.5em')};
  background: ${background};
`;
